import {useState} from 'react';
import logo from "../img/cover.png";
import login from "../img/login.png";
import {auth, provider} from "../firebase";
import { signInWithPopup, signInWithEmailAndPassword} from "firebase/auth";
import {Link, useHistory} from "react-router-dom";

export default function Login({isUser}) {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  if(isUser){
    history.push("/")
  }

  function handleGoogleAuth(){
      signInWithPopup(auth, provider).then((item) => {
          console.log(item.user);
          alert("Authentication Sucessful")
          history.push('/');
      })
  }

  function handleSubmit(e){
    e.preventDefault();

    signInWithEmailAndPassword(auth, email, password).then((item) => {
      alert("Sign In Succesful 💖")
      history.push('/');
    }).catch((err) => {
      if(err.code == "auth/user-not-found"){
        alert("User Not Found")
      }
    })

  }
  return (
    <div className='register form'>
        <div className='left'>
            <div className='form-top'>
                <img src={logo} className = "nav-logo"/>
                <h2>Sign In to PrimeMart</h2>
                <button className="google-auth-button" onClick={handleGoogleAuth}><img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" /><span>Sign in with Google</span></button>
                <p className='or'>or sign In with e-mail</p>
            </div>

            <form onSubmit={handleSubmit}>
                <input type= "email" placeholder='Email Address' value={email} onChange = {e => setEmail(e.target.value)}/>
                <input type= "password" placeholder='Password' value={password} onChange = {e => setPassword(e.target.value)}/>
                <button>Sign In</button>
            </form>
            <p className='already'>Not a member? <Link to = "/register">Register</Link></p>
        </div>
        <div className='right'><img src = {login}/></div>
    </div>
  )
}
